export const invoiceOrderDetailPath = (order, companyId) => {
  if (order?.orderType !== 'invoice') return '';

  if (
    typeof order.invoiceDetailPath === 'string' &&
    order.invoiceDetailPath.startsWith('/invoices/')
  ) {
    return order.invoiceDetailPath;
  }

  const invoiceId = order?.invoiceId || order?.paymentIntentId;
  if (!invoiceId || !companyId) return '';

  const params = new URLSearchParams({companyId});
  return `/invoices/${encodeURIComponent(invoiceId)}?${params.toString()}`;
};

const numericOrderAmount = value => {
  if (value === null || value === undefined || value === '') return null;

  const amount = Number(String(value).replace(/[$,\s]/g, ''));
  return Number.isFinite(amount) ? amount : null;
};

const money = value => (Math.round(Number(value || 0) * 100) / 100).toFixed(2);

export const orderDiscountCode = order => {
  const code = order?.discountCode ?? order?.couponCode;
  return typeof code === 'string' || typeof code === 'number' ? String(code).trim() : '';
};

export const appliedDiscountCodeText = order => {
  const code = orderDiscountCode(order);
  return code ? `(discount code ${code} applied)` : '';
};

export const orderDiscountPricing = order => {
  const code = orderDiscountCode(order);
  if (!code) return null;

  let originalPrice = numericOrderAmount(order?.originalPrice);
  let amountSaved = numericOrderAmount(order?.discountAmount);
  let finalPrice = numericOrderAmount(
    order?.discountedPrice ?? (order?.instReptId ? order?.totalInstAmt : order?.price)
  );

  if (originalPrice === null && amountSaved !== null && finalPrice !== null) {
    originalPrice = finalPrice + amountSaved;
  }
  if (amountSaved === null && originalPrice !== null && finalPrice !== null) {
    amountSaved = Math.max(0, originalPrice - finalPrice);
  }
  if (finalPrice === null && originalPrice !== null && amountSaved !== null) {
    finalPrice = Math.max(0, originalPrice - amountSaved);
  }

  // Legacy package orders only stored the final price and percentage.
  const legacyPercent = numericOrderAmount(order?.couponDiscount);
  if (
    originalPrice === null &&
    amountSaved === null &&
    finalPrice !== null &&
    legacyPercent !== null &&
    legacyPercent > 0 &&
    legacyPercent < 100
  ) {
    originalPrice = finalPrice / (1 - legacyPercent / 100);
    amountSaved = originalPrice - finalPrice;
  }

  if (
    originalPrice === null ||
    amountSaved === null ||
    finalPrice === null ||
    amountSaved <= 0
  ) {
    return null;
  }

  return {
    code,
    originalPrice: money(originalPrice),
    amountSaved: money(amountSaved),
    finalPrice: money(finalPrice),
  };
};

const orderTimestamp = value => {
  const timestamp = new Date(value?.date ?? value).getTime();
  return Number.isFinite(timestamp) ? timestamp : null;
};

export const orderHasMeaningfulUpdate = order => {
  const createdAt = orderTimestamp(order?.createdAt);
  const updatedAt = orderTimestamp(order?.updatedAt);

  return createdAt !== null && updatedAt !== null && updatedAt > createdAt;
};
